import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Menu from "@material-ui/core/Menu";
// import MenuItem from '@material-ui/core/MenuItem';
import {
  userSignOut,
  getUserDetails,
  countLowerCaseChars,
  countUpperCaseChars,
  countSpecialChars,
  countDigits,
} from "actions/Auth";
import IntlMessages from "util/IntlMessages";
import { NavLink, withRouter } from "react-router-dom";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  TableRow,
  TableCell,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import { getPasswordPolicyList } from "actions/PasswordPolicy";
import { updateUserPassword } from "actions/Users";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_ERROR, SHOW_MESSAGE } from "constants/ActionTypes";

const UserInfo = (props) => {
  const activeUser = sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user"))
    : null;
  let passwordpolicy = useSelector(
    (state) => state.passwordpolicies.passwordpolicyList,
  );
  let authUser = useSelector((state) => state.auth.authUser);
  const { loading, message, error } = useSelector(
    ({ commonData }) => commonData,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPasswordPolicyList());
    if (getUserDetails() && getUserDetails().FORCE_CHANGE_PASSWORD == 1) {
      changePassword();
    }
  }, []);

  const [anchorE1, setAnchorE1] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  let [openSnackbar, setOpenSnackbar] = useState(false);
  // let [data, setData] = useState([]);
  let [createResp, setCreateResp] = useState("");
  let [respMessage, setRespMessage] = useState("");

  const handleClick = (event) => {
    setOpen(true);
    setAnchorE1(event.currentTarget);
  };

  const handleClickChangePwd = () => {
    setOpenDialog(true);
  };

  const handleRequestClose = () => {
    setOpen(false);
    setOpenDialog(false);
  };

  const handleDialogRequestClose = () => {
    // this.state
    if (getUserDetails() && authUser.FORCE_CHANGE_PASSWORD == 1) {
      dispatch({ type: FETCH_ERROR, payload: "Please change password" });
    } else {
      setOpenDialog(false);
      setOpen(false);
    }
  };

  const handleClose = () => {
    if (error) {
      setOpenSnackbar(false);
      setOpen(false);
      dispatch({ type: FETCH_ERROR, payload: null });
    } else if (message == "User updated successfully") {
      setOpenSnackbar(true);
      setOpen(true);
      //dispatch({ type: FETCH_ERROR, payload: null });
    } else {
      setOpenSnackbar(false);
      setOpen(false);
      dispatch({ type: SHOW_MESSAGE, payload: null });
    }
    return;
  };

  const changePassword = () => {
    setOpenDialog(true);
    setOpen(false);
  };

  const handleChange = (event) => {
    event.persist();
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
    //data[0].ACTION=event.target.value
    //setData(data)
    //console.log('Form Values',formValues)
  };

  const handleSubmit = async () => {
    let user = getUserDetails();
    let usedPolicy = {};
    for (let index = 0; index < passwordpolicy.length; index++) {
      usedPolicy = passwordpolicy ? passwordpolicy[0] : usedPolicy;
    }
    //console.log('GHGuser',JSON.stringify(user))
    if (formValues.NEW_PASSWORD !== formValues.CONFIRM_PASSWORD) {
      //alert('Need to match password')
      //sessionStorage.setItem('createResp','error')
      //sessionStorage.removeItem('createResp');
      dispatch({ type: FETCH_ERROR, payload: "Password Mismatch" });
      //setCreateResp('error');
      //setRespMessage('Passwords Does not Match');
      //setOpenSnackbar(true);
    } else if (usedPolicy && !formValues.NEW_PASSWORD) {
      dispatch({ type: FETCH_ERROR, payload: "Password must be provided" });
      //setCreateResp('error');
      setRespMessage(
        "Password length must be atleast " +
          usedPolicy.MINIMUM_LENGTH +
          " characters",
      );
      //setOpenSnackbar(true);
    } else if (
      usedPolicy &&
      usedPolicy.MINIMUM_LENGTH > formValues.NEW_PASSWORD.length
    ) {
      dispatch({
        type: FETCH_ERROR,
        payload:
          "Password length must be atleast " +
          usedPolicy.MINIMUM_LENGTH +
          " characters",
      });
      //setCreateResp('error');
      setRespMessage(
        "Password length must be atleast " +
          usedPolicy.MINIMUM_LENGTH +
          " characters",
      );
      //setOpenSnackbar(true);
    } else if (
      usedPolicy &&
      usedPolicy.MINIMUM_UPPER_CASE >
        countUpperCaseChars(formValues.NEW_PASSWORD)
    ) {
      dispatch({
        type: FETCH_ERROR,
        payload:
          "Password must have atleast " +
          usedPolicy.MINIMUM_UPPER_CASE +
          " capital letters",
      });
      //setCreateResp('error');
      setRespMessage(
        "Password must have atleast " +
          usedPolicy.MINIMUM_UPPER_CASE +
          " capital letters",
      );
      //setOpenSnackbar(true);
    } else if (
      usedPolicy &&
      usedPolicy.MINIMUM_LOWER_CASE >
        countLowerCaseChars(formValues.NEW_PASSWORD)
    ) {
      dispatch({
        type: FETCH_ERROR,
        payload:
          "Password must have atleast " +
          usedPolicy.MINIMUM_LOWER_CASE +
          " small letters",
      });
      //setCreateResp('error');
      setRespMessage(
        "Password must have atleast " +
          usedPolicy.MINIMUM_LOWER_CASE +
          " small letters",
      );
      //setOpenSnackbar(true);
    } else if (
      usedPolicy &&
      usedPolicy.MINIMUM_DIGITS > countDigits(formValues.NEW_PASSWORD)
    ) {
      dispatch({
        type: FETCH_ERROR,
        payload:
          "Password must have atleast " +
          usedPolicy.MINIMUM_DIGITS +
          " integers",
      });
      //setCreateResp('error');
      setRespMessage(
        "Password must have atleast " + usedPolicy.MINIMUM_DIGITS + " integers",
      );
      //setOpenSnackbar(true);
    } else if (
      usedPolicy &&
      usedPolicy.MINIMUM_SPECIAL_CHARACTERS >
        countSpecialChars(formValues.NEW_PASSWORD)
    ) {
      dispatch({
        type: FETCH_ERROR,
        payload:
          "Password must have atleast " +
          usedPolicy.MINIMUM_SPECIAL_CHARACTERS +
          " special characters",
      });
      //setCreateResp('error');
      setRespMessage(
        "Password must have atleast " +
          usedPolicy.MINIMUM_SPECIAL_CHARACTERS +
          " special characters",
      );
      //setOpenSnackbar(true);
    } else {
      user.PASSWORD = formValues.NEW_PASSWORD;
      user.SELF = true;
      // alert(user.PASSWORD)

      dispatch(updateUserPassword(user));

      if (sessionStorage.getItem("successChangePass") == "true") {
        dispatch({
          type: SHOW_MESSAGE,
          payload: "Password changed successfully",
        });
        setTimeout(() => {
          setOpenDialog(false);
          setOpen(false);
        }, 3000);
      } else if (sessionStorage.getItem("successChangePass") == "false") {
        dispatch({ type: FETCH_ERROR, payload: "Failed to update" });
        sessionStorage.removeItem("successChangePass");
      }

      // setOpenDialog(false);
      // setOpen(false);

      //alert(message)
      // if(message == 'Password changed successfully'){
      //   //setOpenDialog(false);
      //   //setOpen(false);
      //   alert(message)

      // }

      // setCreateResp('success');
      // setRespMessage('Passwords OK');
      // setOpenSnackbar(true);
    }
    //   if (sessionStorage.getItem('createResp') && sessionStorage.getItem('createResp') == 'success') {
    //     sessionStorage.removeItem('createResp');
    //     setCreateResp('success');
    //     setRespMessage('Password changed successfully');
    //     //setData([formValues]);
    //     setOpenSnackbar(true);
    // } else if (sessionStorage.getItem('createResp') && sessionStorage.getItem('createResp') == 'error') {
    //     sessionStorage.removeItem('createResp');
    //     setCreateResp('error');
    //     setRespMessage('Failed to change password');
    //     setOpenSnackbar(true);

    // }
  };

  return (
    <div className="user-profile d-flex flex-row align-items-center">
      <Avatar
        alt="..."
        src={activeUser ? activeUser.PROFILE_PIC : ""}
        className="user-avatar "
      />
      <div className="user-detail">
        <h4 className="user-name" onClick={handleClick}>
          {activeUser ? activeUser.FIRST_NAME : ""}{" "}
          {activeUser ? activeUser.LAST_NAME : ""}{" "}
          <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
        </h4>
      </div>
      <Menu
        className="user-info"
        id="simple-menu"
        anchorEl={anchorE1}
        open={open}
        onClose={handleRequestClose}
        PaperProps={{
          style: {
            minWidth: 120,
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
      >
        <MenuItem onClick={handleRequestClose}>
          <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
          <IntlMessages id="popup.profile" />
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            changePassword();
          }}
        >
          {/* <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/> */}
          {/* <IntlMessages id="popup.setting"/> */}
          <NavLink to="/app/dashboard">
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-2" />
            <span className="nav-text">
              <IntlMessages id="popup.setting" />{" "}
            </span>
          </NavLink>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleRequestClose();
            dispatch(userSignOut());
          }}
        >
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

          <IntlMessages id="popup.logout" />
        </MenuItem>
      </Menu>

      <Dialog
        open={openDialog}
        onClose={handleDialogRequestClose}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle>{"Change Password"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleClose} style={{ top: "centre", alignContent: "centre" }}>
                                <MuiAlert onClose={handleClose} severity={createResp}>
                                    {respMessage}                    
                                </MuiAlert>
                            </Snackbar> */}
            <Snackbar
              open={error || message ? true : false}
              autoHideDuration={6000}
              onClose={handleClose}
              style={{ top: "centre", alignContent: "centre" }}
            >
              <MuiAlert
                onClose={handleClose}
                severity={message ? "success" : error ? "error" : ""}
              >
                {message ? message : error ? error : ""}
              </MuiAlert>
            </Snackbar>
            <div className="col-md-8 col-12">
              <b>New Password</b>
              <Input
                type="password"
                className="w-100 mb-3"
                name="NEW_PASSWORD"
                inputProps={{ "aria-label": "Description" }}
                margin="normal"
                onChange={(event) => {
                  handleChange(event);
                }}
              />
            </div>
            <div className="col-md-8 col-12">
              <b>Confirm Password</b>
              <Input
                type="password"
                className="w-100 mb-3"
                name="CONFIRM_PASSWORD"
                inputProps={{ "aria-label": "Description" }}
                margin="normal"
                onChange={(event) => {
                  handleChange(event);
                }}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
          color="default"
            variant="contained"
          onClick={handleDialogRequestClose}>
            Close
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserInfo;
